import { useCallback } from 'react';

import { useMultipleQueryParamStates } from './useMultipleQueryParamStates';

type Args = {
  name: string;
};

export function useQueryParamState({
  name,
}: Args): [
  string | undefined,
  (
    value: string | undefined,
    options?: { replace?: boolean; preventScrollReset?: boolean },
  ) => void,
] {
  const [values, setValues] = useMultipleQueryParamStates({ names: [name] });

  const value = values[name];
  const setValue = useCallback(
    (
      newValue: string | undefined,
      options?: { replace?: boolean; preventScrollReset?: boolean },
    ) => {
      setValues(
        { [name]: newValue },
        {
          replace: options?.replace,
          preventScrollReset: options?.preventScrollReset,
        },
      );
    },
    [name, setValues],
  );

  return [value, setValue];
}
